// @flow

import EventNames from '../constants/EventNames';
import Filter from './abstract/Filter';
import DataLayerEventNames from '../constants/DataLayer/EventNames';

export default class RemoveFilter extends Filter {
  #clickHandler: function;
  #button: HTMLElement;

  /**
   * Initiate the remove filter component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setUp(pEl);
    this.#clickHandler = this.handleClick.bind(this);
    this.#button.addEventListener(EventNames.CLICK, this.#clickHandler);
  }

  /**
   * Setup properties and validation
   */
  setUp(pEl: HTMLElement): void {
    const button = pEl.querySelector('[ref="close"]');
    if (button) {
      this.#button = button;
    } else {
      throw new Error('A button is required');
    }
  }

  /**
   * Executes on click
   */
  handleClick(): void {
    window.store.url.removeFilter(this.properties());

    this.dispatch({
      event: DataLayerEventNames.FILTER_USE,
      data: {
        filter: {
          name: this.properties().group,
          value: this.properties().name
        },
        checked: false
      },
      GA4: true
    });

    this.sendFilterNotification();
  }

  /**
   * Destroy all event listeners
   */
  destroy(): void {
    document.removeEventListener(EventNames.CLICK, this.#clickHandler);
    super.destroy();
  }
}
